import { getVendorTaxonomyId } from '@zola-helpers/client/dist/es/marketplace/vendorUtils';

import { isServerApiService } from '~/libs/universal/util/apiServiceType';
import {
  PartialVendorSearch,
  VendorSearchRequest,
} from '~/pages/couples/explore/components/SearchResults/types/types';
import { TaxonomyWithFacetsView } from '~/types/responseTypes';
import type { ClientApiServiceType } from '~/util/apiService';

import { ApiServiceTarget, ServerApiServiceType } from '../server/util/apiService';

export const getSearchableFacets = (
  vendorSearch: VendorSearchRequest | PartialVendorSearch | null,
  apiService: ServerApiServiceType | ClientApiServiceType
): Promise<TaxonomyWithFacetsView[]> => {
  const taxonomyNodeId = getVendorTaxonomyId(vendorSearch?.selectedTaxonomy?.key);
  let url = '/v2/facets/searchable-facets';
  let cacheKey = 'searchable-facets';

  if (taxonomyNodeId) {
    url += `?taxonomy_node_id=${taxonomyNodeId}`;
    cacheKey = `searchable-facets-${taxonomyNodeId}`;
  }

  const options = { cacheKey: [cacheKey] };
  const request = isServerApiService(apiService)
    ? apiService.get<TaxonomyWithFacetsView[]>(ApiServiceTarget.SVC_MARKETPLACE, url, options)
    : apiService.get<TaxonomyWithFacetsView[]>(`/web-marketplace-api${url}`, options);
  return request.catch(() => []);
};
